module.exports = __webpack_public_path__ + "img/atb.75c26787.png";